import { Ptag } from 'components/core/fonts'
import { startCase, toLower } from 'lodash'
import styled from 'styled-components'
import { colors } from 'theme'
import { isValidNumeric } from 'utlis/utils'

function SummaryBox({ field, value, showFullWidth=false }) {

    const flexWidth = {flex: "0 0 16.5rem"}
    const fullWidth = {width: "100%"}
    const keyNameMapping = {
        "Total Claims Submitted": "Submitted"
    }

    const fieldNameHandler = () => {
        if (field in keyNameMapping) {
            return startCase(toLower(keyNameMapping[field]))
        } else {
            return startCase(toLower(field))
        }
    }

    const numericHandler = (numValue) => {
        if(isValidNumeric(numValue) && numValue < 10) {
            return "0" + numValue
        } else {
            return numValue
        }
    }

    return (
      <Box style={showFullWidth ? fullWidth : flexWidth}>
        <div>
          {/* <Ptag fontSize='16px' fontWeight='500' color='#655F77' maxwidth="60%" textTransform="capitalize">Claim</Ptag> */}
          <Ptag
            fontFamily="Montserrat"
            fontSize="14px"
            fontWeight="600"
            color="rgba(100, 96, 117, 0.6)"
            maxwidth="100%"
            textTransform="capitalize"
          >
            {fieldNameHandler()}
          </Ptag>
        </div>
        <Ptag
          fontSize="24px"
          fontWeight="600"
          marginTop="15px"
          fontFamily="Montserrat"
        >
          {numericHandler(value)}
        </Ptag>
      </Box>
    );
}

export default SummaryBox

const Box = styled.div`
  display: flex;
  flex-basis: 20rem;
  flex-direction: column;
  justify-content: space-between;
  /* padding: 18px; */
  /* border: 1px solid #A9A4AE;  */
  border-radius: 8px
`